const CleanseAddressStatus = Object.freeze({
	// the following statuses shows no icon.
	Cleansed: 'Cleansed',
	NotCleansed: 'NotCleansed',

	// the following statuses show the stop icon
	EmptyAddress: 'EmptyAddress',
	MalformedAddress: 'MalformedAddress',
	MultipleMatch: 'MultipleMatch',
	InvalidCandidateAddress: 'InvalidCandidateAddress',
	InvalidRecipient: 'InvalidRecipient',

	// the following status shows the warning icon
	NotFound: 'NotFound',
	ServerFailure: 'ServerFailure',

	// Maximum: 'Maximum',
	// Override: 'Override',
	// Partial: 'Partial',
	// ServerFailure: 'ServerFailure',
	// ExceedMaxLength: 'ExceedMaxLength',
});

export default CleanseAddressStatus;
